import "./Portfolio.css";
import { Helmet } from "react-helmet";
const Portfolio = () => {
  return (
    <>
    <Helmet>
        <title>Interior Design Portfolio | Stunning Residential & Commercial Projects | [interior]</title>
        <meta
          name="description"
          content="Explore our portfolio of stunning residential and commercial interior design projects. See how we transform spaces with unique and customized designs."
        />
        <meta name="keywords" content="interior design portfolio, residential design, commercial design, custom interior design, home design, office design" />
       
      </Helmet>
      <div className="container">
        <div className="row">
          <h2 className="text-center second-heading mt-2">Our Designs</h2>
        </div>
      </div>
      <div className="residental p-4">
        <div className="container">
          <h5 className="about-heading mt-3">Residential</h5>
          <div className="row">
            <div className="col-xl-4 mt-2 image-portfolio">
              <img
                src="/images/rs1.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Decorating a Kitchen</div>
            </div>
            <div className="col-xl-4 mt-2 image-portfolio">
              <img
                src="/images/rs2.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Dunn-edwards living room</div>
            </div>
            <div className="col-xl-4 mt-2 image-portfolio">
              <img
                src="/images/rs3.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
                
              />
              <div class="overlay">Dinner Room</div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 mt-2 image-portfolio">
              <img
                src="/images/rs4.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
               <div class="overlay">Open Living Room</div>
            </div>
            <div className="col-xl-6 mt-2 image-portfolio">
              <img
                src="/images/rs5.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
               <div class="overlay">Black Tiled Bathrooms</div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
          <h5 className="about-heading mt-4 mb-4">Commercial</h5>
          <div className="row">
            <div className="col-xl-8 mt-2 image-portfolio">
              <img
                src="/images/cm4.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Modern Office Furniture Reception Desk</div>
            </div>
            <div className="col-xl-4 mt-2 image-portfolio">
              <img
                src="/images/cm2.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Coworking Space</div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 mb-2 image-portfolio">
              <img
                src="/images/rs6.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Residential</div>
            </div>
            <div className="col-xl-6 mb-2 image-portfolio">
              <img
                src="/images/rs5.png"
                style={{ width: "100%", height: "350px" }}
                className="img-fluid"
              />
              <div class="overlay">Black Tiled Bathrooms</div>
            </div>
          </div>
        </div>
      
    </>
  );
};
export default Portfolio;
